export const GET_CUSTOMERS = 'GET_CUSTOMERS';
export const GET_CUSTOMERS_ALL = 'GET_CUSTOMERS_ALL';
export const ADD_CUSTOMER = 'ADD_CUSTOMER';
export const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER';
